import { type ReactNode } from 'react';

import { useFormatter } from '@eneco/i18n';

import { typeTheme } from './PriceDetails.theme';
import { type FormattedValue } from './PriceDetails.types';
import { DetailsType } from '../../types';

export const formatFormattedValue = (
  currency: ReturnType<typeof useFormatter>['currency'],
  value: FormattedValue,
): string => (typeof value === 'string' ? value : currency.euro(value));

export const formatFormattedValueHighPrecision = (
  currency: ReturnType<typeof useFormatter>['currency'],
  value: FormattedValue,
): string => (typeof value === 'string' ? value : currency.euroHighPrecision(value));

export const resolveTypeIcon = (type?: DetailsType, icon?: ReactNode): ReactNode | undefined =>
  icon ?? (type ? typeTheme[type]?.icon : undefined);

export const useEuroFormatters = () => {
  const { currency } = useFormatter();

  return {
    formatEuro: (value: FormattedValue) => formatFormattedValue(currency, value),
    formatEuroHighPrecision: (value: FormattedValue) => formatFormattedValueHighPrecision(currency, value),
    currency,
  };
};
